import React, { useState, useEffect } from "react";
import Layout from "../../../Layouts";
import ReportPatientTable from "./activtyReportAllTable";
import { Spin, Flex } from "antd";
import rpmService from "../../../../Services/rpmService";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedRpmPatient } from "../../../../Redux/actions/rpmActions";
import dayjs from "dayjs";
function Index() {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [allActivityData, setAllActivityData] = useState([]);
  const { selectedRpmPatient } = useSelector((state) => state.rpm);
  const storedLoginResult = localStorage.getItem("login_result");
  const loginResultObject = storedLoginResult
    ? JSON.parse(storedLoginResult)
    : null;
  const dispatch = useDispatch();
  useEffect(() => {
    fetchRpmActivityReportAll();
  }, []);
  useEffect(() => {
    if (!selectedRpmPatient) {
      const rpmPatientJson = localStorage.getItem("rpmPatient");
      const rpmPatientObject = rpmPatientJson
        ? JSON.parse(rpmPatientJson)
        : null;
      if (rpmPatientObject) dispatch(setSelectedRpmPatient(rpmPatientObject));
    }
  }, []);

  const fetchRpmActivityReportAll = async () => {
    setIsLoading(true);
    const payload = {
      // patientId: selectedRpmPatient?.patientId,
      // hospitalId: selectedRpmPatient?.hospitalId,
      // locationId: selectedRpmPatient?.locationId,
      // providerCode: selectedRpmPatient?.providerCode,
      account_Id: loginResultObject?.user?.account_Id,
      clinic_Id: loginResultObject?.user?.clinic_Id,
      fromDate: dayjs().startOf("month").format("MM/DD/YYYY"),
      toDate: dayjs().endOf("month").format("MM/DD/YYYY"),
      rpmApplicable: "Y",
    };

    try {
      const response = await rpmService.rpmActivityReport(payload);
      setAllActivityData(response.data);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };
  return (
    <Layout>
      <div>
        <div className="">
          <h1 className="font-bold text-xl">Activity Report</h1>

          <div
            className={`${
              isLoading === false && allActivityData?.length === 0
                ? "w-full flex justify-center items-center"
                : ""
            }`}
          >
            {isLoading ? (
              <div className="flex justify-center items-center h-32">
                <Flex align="center" gap="middle">
                  <Spin size="large" tip="Loading..." />
                </Flex>
              </div>
            ) : (
              <ReportPatientTable
                data={allActivityData}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalPages={totalPages}
              />
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Index;
